var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4BeeHexes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "nonzero",
    d: "M49.6406 8.67309V8.6643L35.7829 0.683533L21.9681 8.68243V15.4896L27.7945 18.8352V12.0275L35.7994 7.40936L43.8231 12.0187L43.8483 21.3154L35.767 25.9747L13.9121 13.3588L0.0878906 21.3896L0.113715 37.3934L13.9198 45.3165L27.7945 37.3028V30.5775L27.7725 30.5907L21.9681 27.2401V33.9484L13.8786 38.6176L5.91426 34.0154V24.744L13.928 20.0918L35.8324 32.6676L49.6736 24.6445L49.6406 8.67309Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA4BeeHexes);
export default __webpack_public_path__ + "static/media/a4bee_hexes.151420c336b1f70dddfaaf062df6cb48.svg";
export { ForwardRef as ReactComponent };